/** Normalize ``me`` payloads from WS/REST (aliases + string coercion). */
export function normalizeImposterOnlineMePatch(
  patch: Record<string, unknown>,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...patch };
  const sw = out.secret_word ?? out.secretWord;
  if (sw != null) {
    out.secret_word = typeof sw === "string" ? sw : String(sw);
  }
  delete out.secretWord;

  const hintsRaw = out.secret_word_hints ?? out.secretWordHints;
  if (Array.isArray(hintsRaw)) {
    const hints = hintsRaw
      .filter((x): x is string => typeof x === "string")
      .map((s) => s.trim())
      .filter(Boolean);
    out.secret_word_hints = hints;
  }
  delete out.secretWordHints;

  return out;
}
